import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from 'app/services/models/product.service';
import { SubProductService } from 'app/services/models/sub-product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sub-product-create',
  templateUrl: './sub-product-create.component.html',
  styleUrls: ['./sub-product-create.component.scss']
})
export class SubProductCreateComponent implements OnInit {
  form: FormGroup;
  @Input() data: any;
  public product = [];
  public count: number = 1;

  constructor(
    public ngbModal: NgbActiveModal,
    private productSubProductService: SubProductService,
    private toastrService: ToastrService,
    private productService: ProductService,
    private fb: FormBuilder) {
    this.form = this.fb.group({
      productId: [null, Validators.required],
      count: [null, Validators.required]
    });
  }

  async ngOnInit() {
    console.log(this.data);
    await this.getAllProducts(0, 100, '');
  }

  async getAllProducts(page, size, search) {
    const data = await this.productService.getAllProducts(page, size, search);
    console.log(data);
    this.product = data.products;
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async createProductSerial() {
    if (this.form.valid) {
      const { productId, count } = this.form.value;
      console.log('product ID:', productId);
      console.log('Adet:', count);
      const data = await this.productSubProductService.createSubProduct(this.data,productId,count);
      if(data.status == true){
        this.productService.sendEvent(true);
        this.toastrService.success(data.message,"Alt Ürün Oluşturma");
      }else{
        this.toastrService.error(data.message,"Alt Ürün Oluşturulamadı.");
      }
    }
  }

  

}
